import { QUERY_GET_TAXONOMIES, QUERY_POST_TAXONOMY } from '../../fetch/constantQueries'
import { baseThunk } from '../../fetch/basicThunk';


export const postTaxonomy = baseThunk(`taxonomy/postTaxonomy`, QUERY_POST_TAXONOMY, "POST")
export const getTaxonomies = baseThunk(`taxonomy/getTaxonomy`, QUERY_GET_TAXONOMIES, "GET")

